module.exports = __webpack_public_path__ + "img/controlesimg3ManipulacaoTerceiros.c57e41aa.svg";